import React, {useMemo} from 'react';
import {useSelector} from 'react-redux';
import {ReduxState} from '../../store/types';
import {useTranslation} from 'react-i18next';
import {useStyles} from './AccountPhoneBook.utils';
import usePageTitle from '../../hooks/usePageTitle';
import DetailsWrapper from '../../components/DetailsWraper/DetailsWrapper';
import Loader from '../../components/Loader/Loader';
import {generateTabs} from "../../utils/generateTabs";
import {AccountPermission} from "../../store/types/Permission";
import {useRawPermissions} from "../../hooks/usePermissions";
import PermissionPlaceholder from "../../components/PermissionProvider/PermissionPlaceholder";
import AccountControlPanel from '../AccountControlPanel/AccountControlPanel';
import classNames from 'classnames';
import { AccountPhoneBookList } from './AccountPhoneBookList';
import Header from '../../components/ListViewHeader/Header';
import { CompanyPhoneBookList } from './CompanyPhoneBookList';

export const AccountPhoneBook: React.VFC = () => {
    const classes = useStyles();
    const { t } = useTranslation();
    const permissions = useRawPermissions();

    const {isLoadingPeerContacts} = useSelector(
        (state: ReduxState) => state.accountDashboard,
    );

    usePageTitle();

    const { tabNames, tabs, perm } = generateTabs(
        [
            {
                title:  t('screens:accountPhoneBook.personal'),
                permission: AccountPermission.PhoneBook.PersonalContacts.value,
                tab: (<AccountPhoneBookList />),
            },
            {
                title:  t('screens:accountPhoneBook.company'),
                permission: AccountPermission.PhoneBook.CompanyContacts.value,
                tab: (<CompanyPhoneBookList />),
            },
        ],
        permissions,
    );

    const top = useMemo( () =>  {
        return (
            <div className={classNames(classes.header, classes.headerAccount)}>
                <Header
                    title={t<string>('screens:accountPhoneBook.phoneBook')}
                    dataQa="account-phone-book-header"
                    showDetails={false}
                    hideTotal
                />
                <div className={classes.rightSection}>
                    <AccountControlPanel />
                </div>
            </div>
        )
    }, []);

    if (isLoadingPeerContacts) {
        return (
            <div className={classes.loader}>
                <Loader dataQa="account-phone-book-loader"/>
            </div>
        );
    }

    return (
        <PermissionPlaceholder
            permission={AccountPermission.PhoneBook.value}
        >
            <DetailsWrapper
                tabs={tabs}
                tabsNames={tabNames}
                top={top}
                defaultTabIndex={0}
                perm={perm}
                headerCustomClass={classes.headerAccountContainer}
            />
        </PermissionPlaceholder>
    );
};
